import Types from "../types";

export function onWorkChange(work) {
  return { type: Types.WORK_CHANGE, work: work };
}

export function onUploadingChange(uploading) {
  return { type: Types.UPLOADING_CHANGE, uploading: uploading };
}

export function onUploadPercentChange(uploadPercent) {
  return { type: Types.UPLOADPERCENT_CHANGE, uploadPercent: uploadPercent };
}

export function onProcessPercentChange(processPercent) {
  return { type: Types.PROCESSPERCENT_CHANGE, processPercent: processPercent };
}

export function onProcessStepChange(processStep) {
  return { type: Types.PROGRESSSTEP_CHANGE, processStep: processStep };
}

export function onCurrProgressChange(currProgress) {
  return { type: Types.CURRPROGRESS_CHANGE, currProgress: currProgress };
}

export function onStartTimeChange(startTime) {
  return { type: Types.STARTTIME_CHANGE, startTime: startTime };
}

export function onCancelProgressChange(cancelProgress) {
  return { type: Types.CANCELPROGRESS_CHANGE, cancelProgress: cancelProgress };
}

export function onFileToBlobStatusChange(fileToBlobStatus) {
  return { type: Types.FILETOBLOBSTATUS_CHANGE, fileToBlobStatus: fileToBlobStatus };
}

export function onSubmittingChange(submitting) {
  return { type: Types.SUBMITTING_CHANGE, submitting: submitting };
}

export function onUploadXHRChange(uploadXHR) {
  return { type: Types.UPLOADXHR_CHANGE, uploadXHR: uploadXHR };
}

export function onFetchAbortChange(fetchAbort) {
  return { type: Types.FETCHABORT_CHANGE, fetchAbort: fetchAbort };
}

export function onToGifObjChange(toGifObj) {
  return { type: Types.TOGIFOBJ_CHANGE, toGifObj: toGifObj };
}

export function onCropChange(crop) {
  return { type: Types.CROP_CHANGE, crop: crop };
}

export function onAudioCompressListChange(audioCompressList) {
  return { type: Types.AUDIOCOMPRESSLIST_CHANGE, audioCompressList: audioCompressList };
}

export function onAudioExtractorFileChange(audioExtractorFile) {
  return { type: Types.AUDIOEXTRACTORFILE_CHANGE, audioExtractorFile: audioExtractorFile };
}

export function onAudioJoinerListChange(audioJoinerList) {
  return { type: Types.AUDIOJOINERLIST_CHANGE, audioJoinerList: audioJoinerList };
}

export function onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj) {
  return { type: Types.AUDIOCUTSPEEDVOLUMEOBJ_CHANGE, audioCutSpeedVolumeObj: audioCutSpeedVolumeObj };
}

export function onAudioAddMusicListChange(audioAddMusicList) {
  return { type: Types.AUDIOADDMUSICLIST_CHANGE, audioAddMusicList: audioAddMusicList };
}

export function onVideoCompressObjChange(videoCompressObj) {
  return { type: Types.VIDEOCOMPRESSOBJ_CHANGE, videoCompressObj: videoCompressObj };
}

export function onVideoMuteObjChange(videoMuteObj) {
  return { type: Types.VIDEOMUTEOBJ_CHANGE, videoMuteObj: videoMuteObj };
}

export function onImageCutoutObjChange(imageCutoutObj) {
  return { type: Types.IMAGECUTOUTOBJ_CHANGE, imageCutoutObj: imageCutoutObj };
}